<template>
    <div class="agreem">
        <div class="agreemtop">
            <div class="agreemt_top_top">
                <div class="flexcent" style="margin-bottom: 20px;">
                    <h1>牙管家系统协议书</h1>
                </div>
                <br>
                <div style="margin-left: 50px;display: flex;">
                    <p>甲方：</p>
                    <p>{{corporation.CompanyName}}</p>
                </div>
                <br>
                <div style="margin-left: 50px;display: flex;">
                    <p>乙方：</p>
                    <p>牙管家（杭州）网络科技有限公司</p>
                </div>
                <br>
                <p style="text-indent:2em;">
                    欢迎使用牙管家（杭州）网络科技有限公司（以下简称“牙管家”）
                    “牙管家义齿管理平台”软件（以下简称“本软件”）及服务，在此特别提醒您（用户）
                    在注册成为用户之前，请认真阅读本《用户协议》（以下简称“本协议”），
                    确保您充分理解本协议中各条款，请您务必审慎阅读、充分理解各条款内容，
                    特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议。
                </p>
                <br>
                <p style="text-indent:2em;">
                    请您审慎阅读并选择接受或不接受本协议。除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用本软件及相关服务。
                    您的下载、安装、使用、获取牙管家帐号、登录等行为即视为您已阅读并同意上述协议的约束。
                    本协议约定牙管家与用户之间关于“本软件”软件服务（以下简称“服务”）的权利义务。
                    “用户”是指注册、登录、使用本服务的企业。本协议牙管家随时更新，更新后的协议条款一旦公布即代替原来的协议条款，
                    恕不再另行通知，用户可在本网站查阅最新版协议条款。在牙管家修改协议条款后，如果用户不接受修改后的条款，
                    请立即停止使用牙管家提供的服务，用户继续使用牙管家提供的服务将被视为接受修改后的协议。
                </p>
                <br>
                <p style="text-indent:2em;">
                    甲乙双方，经友好协商一致，就甲方租用乙方企业应用系统软件服务签订以下协议。双方申明，双方都已理解并认可了本协议的所有内容，同意承担各自应承担的权利和义务，忠实地履行本协议。为明确双方的权利义务关系，经双方协商一致，签定本协议。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第一条 企业应用系统软件租用范围；甲方根据自身的业务和管理需要，向乙方租用基于乙方；
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1.甲方租用模块，具体内容为：前台模块，生产管理模块，车间模块，财务模块，统计模块，业务管理模块，药监模块，外部查询模块等功能模块。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 甲方租用期限为甲方终止为乙方支付软件服务费为止。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 甲方租用费为 ：安装和首次培训费用为以双方约定协商为准，首次安装包括首年服务费和软件初始化培训费。服务费以年付的付款方式支付。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第二条 甲方的权利和义务
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 在软件租用过程中，甲方有责任与乙方相互配合，保证有专人负责甲、乙双方的沟通工作。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 在软件使用过程中，甲方有权利要求乙方指派专人负责系统的初始化工作。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 在软件租用过程中，甲方有权利要求乙方指派专人负责软件使用的培训和技术指导工作。如需上门服务费用由甲方承担。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    4. 禁止出售、转售或复制、开发试用权限，禁止基于商业目的模仿乙方软件的产品和服务；禁止复制和模仿乙方软件的设计理念、界面、功能和图表。甲方只能处于公司商业范围内使用服务，禁止发送兜售信息和违反法律的信息，禁止发送和储存带有病毒、蠕虫、木马和其他有害计算机的代码、文件、脚本和程序。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    5. 甲方应对其账号下所发生的任何行为负责并遵守地方、国家所有与适用本服务有关的适用法律、法规；有责任通知本软件任何未经许可使用帐号、密码或破坏数据安全的行为。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    6. 甲方在使用本系统软件时，应当注意符合国家法律规定和社会公共利益，遵守《计算机信息网络国际联网安全保护管理办法》、《中华人民共和国计算机信息网络国际联网管理暂行规定》、《互联网信息服务管理办法》等。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    7. 甲方应按照协议约定，及时向乙方支付软件租用及服务费用。如甲方在规定期限内未履行付款义务，乙方有权利终止甲方软件租用服务，由此造成的所以损失及费用由甲方自行承担。 
                </p>
                <br>
                <p style="text-indent: 2em;">
                    8. 首次安装软件以及上门服务产生的差旅费按约定协商解决。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第三条 乙方权利和义务
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 乙方应按照协议约定，向甲方提供协议约定的软件租用服务。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 在甲方租用协议期间，乙方有义务指派专人负责甲乙双方的沟通协作，乙方指派客服人员远程沟通协作服务。如需乙方上门服务甲方应报销乙方差旅费，食宿费和差旅补助。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 在软件使用初期，乙方有义务按照甲方要求指派专人负责甲方租用软件系统的初始化工作。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    4. 在软件租用过程中，乙方有义务按照甲方要求指派专人负责软件使用的培训和技术指导工作。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    5. 乙方有义务根据甲方要求将甲方的数据资料完整提供给甲方，不得有任何推诿。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    6. 协议到期后，双方应本着平等、友好协商继续合作事宜。如双方不再合作，甲方如需要数据资料乙方应协助甲方将甲方本地所有数据完整从甲方服务器内导出归还甲方，并不得留有任何备份。乙方不得利用软件控制权，及任何理由向甲方增收相关费用或要求甲方继续合作。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    7. 乙方应协助甲方做好数据安全防护措施，保证甲方数据的安全性。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    8. 经甲方同意，本协议的签署意味着甲方授权乙方在履行本协议时可以使用甲方的名称、商标、域名、企业标志等，使用范围仅限于乙方自身宣传使用，不得作为其他用途，且在使用中不能损害甲方的利益。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第四条 账号和数据安全
                </p>
                <br>
                <p style="text-indent: 2em;">
                    乙方应采取相应的管理、以及技术措施保护甲方“数据”的安全性、私密性和完整性。除提供“服务”、防范或解决服务或技术故障或经甲方请求连接客户支持等事项外，不得访问甲方“数据”。双方应当保守在履行本协议过程中获知的对方商业秘密。本协议的终止、撤消、无效不应影响本条款约定的效力。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第五条 与第三方网站的链接
                </p>
                <br>
                <p style="text-indent: 2em;">
                    乙方提供与第三方网站的链接仅仅为了给甲方带来方便。如果甲方使用这些链接，将离开本软件管理软件站点。本软件没有审查过任何第三方站点，对任何站点及其内容或它们的保密政策不进行控制，也不负任何责任。因此，本软件对这些网站上的任何信息、软件以及其它产品或材料，或者通过使用它们可能获得的任何结果不予认可，也不作任何表述。如果甲方决定访问本在线管理软件链接的任何第三方站点，其风险完全由甲方自己承担。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第六条 第六条网络延迟
                </p>
                <br>
                <p style="text-indent: 2em;">
                    本软件提供的“服务”可能会因Internet和电子通信固有的缺陷而产生限制、延迟和其它问题，本软件对因这些问题造成的任何延误、发送失败或其它损失不承担责任。但乙方有义务尽量解决网络延迟给客户造成的问题。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第七条 服务和费用
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 在签订协议后，甲方在遇到任何使用问题乙方应给于甲方急时解决。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 乙方给与甲方提供服务采取网络远程服务。如需乙方上门服务时甲方应报销乙方差旅费，食宿费用和差旅补助。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 协议签订之后，如需进行调整功能，甲方有权利告知乙方，配合乙方完成甲方功能需求。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    4. 需求开发时间：为当月月底之前告知乙方，乙方下月初对软件进行修改次月升级。如有未完善的功能乙方应通知甲方延后处理。具体时间有甲乙双方协商而定。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    5. 特殊需求：在甲方提供一些无理需求时，乙方有权拒绝开发并告知甲方，协商解决。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第八条 协议的变更与解除
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 协议履行过程中，任何一方欲对协议期限、项目内容、费用等协议内容或条款进行变更或补充，应与对方协商一致并签定补充协议进行确定。否则，视为未作变更或补充，双方仍应按照原协议的约定履行。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 协议履行过程中，如甲方欲提前解除协议，应提前15日通知乙方。甲方提前解除协议，已支付的当年费用不予退还。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 如乙方因自身原因需提前解除协议，应提前30日通知甲方，并返还乙方未履行而甲方已支付的从解除协议之日起的软件租用及服务费用。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    4. 任何一方在履行中发现或者有证据表明对方已经、正在或将要违约，可以中止履行本协议，但应及时通知对方。若对方继续不履行、履行不当或者违反本协议，该方可以解除本协议并要求对方赔偿损失。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第九条 不可抗力及责任承担
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 如果出现不可抗力，双方在本协议中的义务在不可抗力影响范围及其持续期间内将中止履行。任何一方均不会因此而承担责任。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 由此而产生的服务费用问题，按实际使用时间来结算，余款退回。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第十条 争议解决
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 双方当事人对本协议的订立、解释、履行、效力等发生争议，应友好协商解决；协商不成，双方同意向位于本地有管辖权的人民法院提交诉讼。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 本协议的终止、撤消、无效不应影响前款约定的效力。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    第十一条 其他
                </p>
                <br>
                <p style="text-indent: 2em;">
                    1. 一方变更联系人、通讯地址或者联系方式，应及时将变更后的联系人、通讯地址或者联系方式通知另一方，否则变更方应对此造成的一切后果承担责任。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    2. 本协议的订立、解释、履行、效力和争议的解决等均适用中华人民共和国法律。对本协议协议的理解与解释应根据原意并结合本协议目的进行。
                </p>
                <br>
                <p style="text-indent: 2em;">
                    3. 如果本协议任何条款根据现行法律被确定为无效或无法实施，本协议的其他所有条款将继续有效。此种情况下，双方将以有效的约定替换该约定，且该有效约定应尽可能接近原约定和本协议相应的精神和宗旨
                </p>
                <br>
                <p style="text-indent: 2em;">
                    4. 本协议签订，具有同等法律效力。
                </p>
                <br>
                <div style="display: flex;justify-content: end;">
                    <p>{{corporation.ConsentTime}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            corporation:{
                CompanyName:'',
                ConsentTime: null
            },
        }
    },
    async mounted(){
        let data = `?companyId=${this.$route.query.companyId}`
        await this.$http.getAgreement(data).then(res=>{
            console.log(res)
            if(res.status == 200 || res.status == 204) {
				if(res.data.ConsentTime){
					this.corporation.ConsentTime = res.data.ConsentTime.split('T')[0]
				}
                this.corporation.CompanyName = res.data.CompanyName
            } else {
                this.$message("查询失败")
            }
        })
    },
    methods:{

    }
}
</script>

<style>
.agreem{
    background-color: #E9EEF3;
    height: 100vh;
}
.agreemtop{
    background-color: #E9EEF3;
    padding: 20px 0;
}
.agreemt_top_top{
    width: 960px;
    margin: 0 auto;
    background-color: #FFFFFF;
    border: 1px #d9d9d9 solid;
    padding: 30px;
}
.flexcent{
    display: flex;
    justify-content: center;
}
</style>